import Button from "../../Tools/Components/Button";

function VeldAlias(props) {
    var leftFieldName = props.VeldAlias.promptFieldName;
    var rightFieldName = props.VeldAlias.mkgFieldName;
    var editing = props.editing;
    var onLeftChanged = props.onLeftChanged;
    var onRightChanged = props.onRightChanged;
    var onDeletePressed = props.onDeletePressed;
    var id = props.index;
    
    var left = GetEditableField(onLeftChanged, leftFieldName, editing);
    var right = GetEditableField(onRightChanged, rightFieldName, editing);

    return (
        <div className="content-stretch flex gap-[7px] items-center relative shrink-0 w-full" id={"va" + id}>
            {left}
            <div>:</div>
            {right}
            {editing ? <Button text="X" onClick={onDeletePressed} width="30" height="30"/> : ""}
        </div>
    );
} export default VeldAlias

function GetEditableField(callback, value, editing){
    return editing ? (<input onChange={value => callback(value.target.value)} className="bg-[#ffffff] dark:bg-gray-700 h-[23px] relative shrink-0 w-[320px] absolute border border-black border-solid inset-0" defaultValue={value} />) :
    (<input className="bg-[#dedede] dark:bg-gray-800 h-[23px] relative shrink-0 w-[320px] absolute border border-black border-solid inset-0 pointer-events-none" defaultValue={value}/>);
}